exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-box{position:relative}.drawer-box .main-content,.drawer-container .main-content{position:relative;padding:10px;box-sizing:border-box;height:100%}.rmc-drawer-sidebar{background-color:#fff}.drawer-box .list-group-item{display:flex;align-items:center;background-color:transparent;margin-bottom:5px;border:0;padding:5px}.drawer-box .rmc-drawer-sidebar{position:fixed}.inside-drawer{width:280px}.drawer-container{position:relative;height:400px}.drawer-container .rmc-drawer-overlay,.drawer-container .rmc-drawer-sidebar{position:absolute}.rmc-drawer-docked .rmc-drawer-content{border-left:1px solid #d9d9d9}.rmc-drawer-sidebar-dark-theme{margin-top:50px;padding-top:15px;width:auto}.rmc-drawer-sidebar-dark-theme ul{margin:0;padding:0}.rmc-drawer-sidebar-dark-theme ul li{margin:0;padding:6px 15px!important;font-size:16px;font-weight:400}.rmc-drawer-sidebar-dark-theme ul li:hover{background-color:#ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./components/Drawer/simple.css
// module id = 1378
// module chunks = 16